import { writable } from 'svelte/store';

import { isValidJSON } from 'src/helpers/validators';

export const blur_ts = writable(JSON.parse(sessionStorage.getItem('blur_ts')) || 0);
blur_ts.subscribe((val) => sessionStorage.setItem('blur_ts', JSON.stringify(val)));

export const initializing_language = writable(JSON.parse(localStorage.getItem('initializing_language')));
initializing_language.subscribe((val) => {
	if (val) {
		localStorage.setItem('initializing_language', JSON.stringify(val));
		localStorage.setItem(
			'user_data',
			JSON.stringify({
				...(isValidJSON(localStorage.getItem('user_data'))
					? (JSON.parse(localStorage.getItem('user_data')) ?? {})
					: {}),
				lang: val,
			}),
		);
		localStorage.setItem(
			'user_settings',
			JSON.stringify({
				...(isValidJSON(localStorage.getItem('user_settings'))
					? (JSON.parse(localStorage.getItem('user_settings')) ?? {})
					: {}),
				lang: val,
			}),
		);
	}
});

export const display = writable(JSON.parse(localStorage.getItem('display')) || 'm');
display.subscribe((val) => localStorage.setItem('display', JSON.stringify(val)));

export const isUsingGroupSlider = writable(false);

export const app_icon = writable(
	localStorage.getItem('app_icon') ? JSON.parse(localStorage.getItem('app_icon')) : 'default',
);
app_icon.subscribe((val) => localStorage.setItem('app_icon', JSON.stringify(val)));
